import qs from 'qs'
/**
 * 判断是否为空对象
 * @param {*} object 源对象
 */
 export const isEmptyObject = (object) => {
	return Object.keys(object).length === 0
}

/**
 * 是否在数组内
 */
export const inArray = (search, array) => {
	for (let i in array) {
		if (array[i] == search) return true
	}
	return false
}

/**
 * 判断是否为数组
 * @param {*} array
 */
export const isArray = (array) => {
	return Object.prototype.toString.call(array) === '[object Array]'
}

/**
 * 判断是否为对象
 * @param {*} object
 */
export const isObject = (object) => {
	return Object.prototype.toString.call(object) === '[object Object]'
}

/**
 * 判断是否为字符串
 */
export const isString = (string) =>{
  return Object.prototype.toString.call(string) === '[object String]'
}


/**
 * 对象转URL
 * @param {object} obj
 */
export const urlEncode = (obj = {}) => {
	const result = []
	for (const key in obj) {
		const item = obj[key]
		if (!item) {
			continue
		}
		if (isArray(item)) {
			item.forEach(val => {
				result.push(key + '=' + val)
			})
		} else {
			result.push(key + '=' + item)
		}
	}
	return result.join('&')
}

/**
 * 判断是否为空
 * @param {*} object 源对象
 */
export const isEmpty = (value) => {
	if (isArray(value)) {
		return value.length === 0
	}
	if (isObject(value)) {
		return isEmptyObject(value)
	}
	return !value
}

/**
 * 防抖
 * isImediate: true - 执行前置；false - 执行后置；
 */
export const debounce = (func, wait, isImediate) => {
  let timmer = null
  return function (...args) {
    if (timmer) clearTimeout(timmer)
    if (isImediate) {
      const callNow = !timmer
      timmer = setTimeout(() => {
        timmer = null
      }, wait)
      if (callNow) {
        func(...args)
      }
    } else {
      timmer = setTimeout(() => {
        func(...args)
      }, wait)
    }
  }
}

/**
 * 节流
 */
export const throttle = (func, wait) => {
	let pre = 0
	return function(...args) {
		const cur = Date.now()
		if (cur - pre >= wait) {
			func(...args)
			pre = Date.now()
		}
	}
}

export const chunk = (array, size = 1) => {
	var result = [];
	for (var i = 0, len = array.length; i < len; i += size) {
		result.push(array.slice(i, i + size));
	}
	return result;
}

export const parseUri = (url) => {
	var params = {},
		h;
	var hash = url.slice(url.indexOf("?") + 1).split('&');
	for (var i = 0; i < hash.length; i++) {
		h = hash[i].split("="); //
		params[h[0]] = h[1];
	}
	return params;
}

/*
  版本比较
*/
export function compareVersion(v1, v2) {
  v1 = v1.split('.')
  v2 = v2.split('.')
  const len = Math.max(v1.length, v2.length)

  while (v1.length < len) {
    v1.push('0')
  }
  while (v2.length < len) {
    v2.push('0')
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i])
    const num2 = parseInt(v2[i])

    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }

  return 0
}


/**
* @function parseQuery
* @param  {string} url {要解析的串，空则使用location.href}
* @return {object} {参数对象}
*/
export const parseQuery = (url) => {
  return parseUrl(url).params
}


/**
* @function parseUrl
* @param  {string} url {要解析的串，空则使用location.href}
* @return {object} {{uri, hash, params}}
*/
export const parseUrl = (url) => {
  url = url || window.location.href
  const decoder = (v) => {
    return window.decodeURIComponent(v)
  }
  const parts = url.split('?')
  const uri = parts[0]
  const [query, hash] = parts[1] ? parts[1].split('#') : ['', '']
  const params = qs.parse(query, { decoder })

  return { uri, hash, params }
}
/**
* @function buildQuery
* @param  {object} params     {参数对象}
* @param  {string} url = null {初始url串，null则使用location.href, ''则只返回query串}
* @return {string} {url}
*/
export const buildQuery = (params, url = null) => {
  const argUrl = url
  const encoder = (v) => {
    return window.encodeURIComponent(v)
  }
  if (url == null) {
    url = window.location.href
  } else if (argUrl === '') {
    return qs.stringify(params, { encoder })
  }

  const urlObj = parseUrl(url)
  //params 原有curPageParams,
  //urlObj.params url参数
  params = Object.assign( params,urlObj.params)
  const query = qs.stringify(params, { encoder })
  let newUrl = urlObj.uri
  if (query) {
    newUrl = newUrl + '?' + query
  }
  if (urlObj.hash) {
    newUrl = newUrl + '#' + urlObj.hash
  }

  return newUrl
}


export const checkIsValid = (item) => {
  switch (typeof (item)) {
    case 'undefined': return false
    case 'null': return false
    case 'number': {
      if (isNaN(item)) {
        return false
      } else {
        return true
      }
    }
    case 'object': {
      for (const key in item) {
        return true
      }
      return false
    }
  }
}

// 切割字符串方法
export const resolveTaggedText = function (text, startTag, endTag) {
  const charList = text.split('')
  const output = []
  let currentText = ''
  let ifInHighlight = false
  charList.forEach((char) => {
    if (char === startTag) {
      if (!ifInHighlight) {
        output.push({
          highlight: false,
          content: currentText
        })
        currentText = ''
        ifInHighlight = true
      } else {
        currentText = currentText.concat(char)
      }
    } else if (char === endTag) {
      if (ifInHighlight) {
        output.push({
          highlight: true,
          content: currentText
        })
        currentText = ''
        ifInHighlight = false
      } else {
        currentText = currentText.concat(char)
      }
    } else {
      currentText = currentText.concat(char)
    }
  })
  currentText.length && output.push({
    highlight: ifInHighlight,
    content: currentText
  })
  return output
}

export const padStart2O = (num) => {
  num = num.toString()
  return num[1] ? num : `0${num}`
}

/**
 * 格式化时间
 * @returns 2019/09/16
 */
export const formatDate = (date, separator = '/') => {
  if (!date) return
  const newDate = new Date(date)

  const year = newDate.getFullYear()
  const month = newDate.getMonth() + 1
  const day = newDate.getDate()
  return [year, month, day].map(padStart2O).join(separator)
}

/**
 * 倒计时剩余时间格式化
 * @param {Number} now 当前时间戳，如果不传 end 则该字段表示剩余毫秒数
 * @param {Number} end 结束时间戳
 */
 export const timeStampDiff = (now = 0, end, showDays = false) => {
  let remainingMs = 0
  if (end) {
    if (now >= end) {
      return { hours: padStart2O(0), minutes: padStart2O(0), seconds: padStart2O(0), milliseconds: '0' }
    }
    remainingMs = end - now
  } else {
    remainingMs = now
  }

  const days = Math.floor(remainingMs / 1000 / 3600 / 24)
  const hours = showDays ? Math.floor((remainingMs / 1000 / 3600) % 24) : Math.floor(remainingMs / 1000 / 3600)
  const minutes = Math.floor((remainingMs / 1000 / 60) % 60)
  const seconds = Math.floor((remainingMs / 1000) % 60)
  const milliseconds = Math.floor(remainingMs % 1000)
  return {
    days,
    hours: padStart2O(hours),
    minutes: padStart2O(minutes),
    seconds: padStart2O(seconds),
    milliseconds: Math.floor(parseInt(milliseconds / 100) % 10)
  }
}

/**
 * base64转二进制
 * @param {*} code base64
 */
export const base64ToBlob = (code) => {
  const parts = code.split(';base64,')
  const contentType = parts[0].split(':')[1]
  const raw = window.atob(parts[1])
  const rawLength = raw.length
  const uInt8Array = new Uint8Array(rawLength)
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i)
  }
  return new Blob([uInt8Array], {
    type: contentType
  })
}

/**
 *
 * @param {string} text
 * @param {string} sign
 * @returns
 */
export function magicArr (text, sign) {
  if (!text) {
    return []
  }
  if (!sign) sign = '#_$'
  return text.split(sign)
}

/**
 * 价格过滤器
 * 将价格（单位分）转化成展示形式
 * 如：
 * formatPrice(1250) // '12.5'
 * formatPrice(1250, '¥') // '¥12.5'
 * formatPrice(1250, '¥', 2) // '¥12.5'
 * formatPrice(1250, '¥', 2, true) // '¥12.50'
 * @param {number} val 单位为分的价格
 * @param {string} symbol 价格符号 默认'' 传入如：'¥' 或者 '$'
 * @param {number} precision 保留的小数位数 默认2
 * @param {boolean} fixedPrecision false时，会清掉小数后的末尾0，如：'12.50'会变成'12.5'；设置为true时，会保留小数后的末尾0；默认为false
 */

 export const formatPrice = (val, symbol, precision, fixedPrecision) => {
  var res
  symbol = symbol || ''
  precision = (precision == null) ? 2 : precision
  val = parseFloat(val / 100).toFixed(precision)
  // 非固定位数
  if (!fixedPrecision) {
    val = parseFloat(val)
  }
  if (val === '0.0') {
    res = '0'
  } else {
    res = val
  }
  if (isNaN(res)) {
    res = ''
  }
  res = symbol + res
  return res
}

/**
 * 颜色过滤器
 * 将十进制色值转化成style对应属性样式；
 *
 * 如：
 * deciToHex(0)
 * 返回：'#000000'
 * @param {number} val 十进制色值
 */
 export const deciToHex = (val) => {
  if (!val || typeof val.toString !== 'function') return val

  let v = val.toString(16)
  if (v.length < 6) {
    v = '0'.repeat(6 - v.length) + v
  }
  return '#' + v
}

/*
分割价格
 */
export const splitPrice = (price) => {
  if (typeof price === 'undefined') {
    price = ''
  }
  var _prices = price.toString().split('.');
  return _prices;
}

/**
 * b数组是否被包含在a数组中
 * @param {*} a [[1,2,3],[3,4]]
 * @param {*} b [1,3]
 * @returns
 */
export const isContained = (a, b) => {
  if (!(a instanceof Array) || !(b instanceof Array)) return false;
  const len = b.length;
  if (a.length < len) return false;
  for (let i = 0; i < len; i++) {
      if (!a.includes(b[i])) return false;
  }
  return true;
};

/**
 * 手机号格式校验
 * @param {*} value 手机号
 * @returns
 */
export const isMobile = (value) => {
  value = value.replace(/[^-|\d]/g, '');
  return /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value);
}
export const get7moorParams = (type='custom') => {
  try {
    const newStringUrl = location.href.replace(/&quot;/g, '"')
    let url = new URL(newStringUrl);
    let params = new URLSearchParams(url.search);
    const allParams = parseQuery(newStringUrl)
    let customFieldString = params.get('customField');
    let customField = JSON.parse(customFieldString);
    if (type === 'custom') {
      // console.log('customField', customField)
      return { ...customField, systemType: customField.systemType || customField.type }
    } else {
      return allParams
    }
  } catch (e) {
    return {}
  }
}

export const copy =(data)=>{
  var inputEl = document.createElement('input')
  inputEl.setAttribute('readonly', '')
  inputEl.value = data
  document.body.appendChild(inputEl)
  inputEl.select()
  inputEl.setSelectionRange(0, data.length)
  document.execCommand('Copy')
  inputEl.remove()
}

/** 折扣 */
export const formatDiscount = (value) => {
  if (value) {
    return (parseFloat(value) * 10).toFixed(1)
  } else {
    return ''
  }
}

/** 元 */
export const yuan = (value) => {
  return value ? (Math.ceil(value) / 100).toFixed(2) : '0.00'
}

export const formatNum = (num) => {
  //1. 可能是字符串，转换为浮点数
  //2. 乘以100 小数点向右移动两位
  //3. Math.round 进行四舍五入
  //4. 除以100 小数点向左移动两位 实现保留小数点后两位
  var value = Math.round(parseFloat(num) * 100) / 100;
  // 去掉小数点 存为数组
  var arrayNum = value.toString().split(".");
  //只有一位（整数）
  if (arrayNum.length == 1) {
    return value.toString() + ".00";
  }
  if (arrayNum.length > 1) {
    //小数点右侧 如果小于两位 则补一个0
    if (arrayNum[1].length < 2) {
        return value.toString() + "0";
    }
    return value;
  }

}